const init = () => {
  const $obj = $('[data-plugin="menu-header"]')
  const getHtml = $.get('/asset/html/menu-header.html')
  getHtml.then( html => {
    $obj.each( (i,v) => $(v).replaceWith( html ) )
  })
}

export default function GET_MENU_PLAN () {
  init()
}